import React from 'react';
import PropTypes from 'prop-types';

function ProjectNoParameters({ message }) {
  return <div className="project-status-grid-item__no-results">{message}</div>;
}

ProjectNoParameters.defaultProps = {
  message: 'Transferred from reaction results: no parameters',
};

ProjectNoParameters.propTypes = {
  message: PropTypes.string,
};

export default ProjectNoParameters;
